import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../interfaces/Centres";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {CentreService} from "../../../services/centre.service";
import {EducationService} from "../education.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ChildService} from "../../../components/child/child.service";
import {DatePipe, TitleCasePipe} from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {
  ViewEducationIndividualComponent
} from "../components/view-education-individual/view-education-individual.component";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {ViewEducationGroupComponent} from "../components/view-education-group/view-education-group.component";
import {FullChild} from "../../../interfaces/FullChild";
import {MatSelectChange} from "@angular/material/select";

@Component({
  selector: 'app-education-child-report',
  templateUrl: './education-child-report.component.html',
  styleUrls: ['./education-child-report.component.scss']
})
export class EducationChildReportComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  centres$: Observable<Centre[]>
  educationData: any[] = []
  dataSourceIndividual = new MatTableDataSource(this.educationData);
  dataSourceGroup = new MatTableDataSource(this.educationData);
  mAllIndividualData: any[] = []
  mAllGroupData: any[] = []
  mFilteredData: any[] = []
  mFilteredGroupData: any[] = []
  displayedColumns: string[] = ['childName', 'centreName', 'sessionDate', 'startTime', 'sessionType', 'subject', 'submittedBy', 'createdAt', 'action'];
  displayedColumns2: string[] = ['childName', 'centre', 'date', 'timing', 'type_session', 'subject', 'topic_covered', 'remark', 'teacher', 'createdAt', 'action'];
  selectedCentre?: string | null = ''
  selectedChildCode?: any;
  childBycentre: Observable<FullChild[]> | undefined;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  showIndividual = true;
  showGroup = true;
  sessionType = '' //*individual type
  sessionType2: any; //*group type

  constructor(readonly centreService: CentreService,
              readonly eduationService: EducationService,
              readonly matSnackBar: MatSnackBar,
              readonly childService: ChildService,
              private titlecasePipe: TitleCasePipe,
              private readonly matDialog: MatDialog,
              private datePipe: DatePipe,
              private educationService: EducationService,) {
    this.centres$ = centreService.getAllCentres()
    this.mFilteredData = []

  }

  ngOnInit(): void {


  }

  private fetchIndividualStudentData() {
    this.educationService.getIndividualEducationListByCenter(this.selectedChildCode.childCode).pipe(takeUntil(this._destroyed$)).subscribe(re => {
      this.mAllIndividualData = re
      this.mFilteredData=this.mAllIndividualData
      this.dataSourceIndividual = new MatTableDataSource(this.mFilteredData);
      this.dataSourceIndividual.sort = this.sort!;
      this.dataSourceIndividual.paginator = this.paginator!;
    })
  }

  private fetchGroupStudentData(childObject: any) {
    this.educationService.getGroupEducationSessionsByCenter(childObject).pipe(takeUntil(this._destroyed$)).subscribe(re => {
      this.mAllGroupData = re
      // console.log(this.educationData)
      // this.mAllData = this.educationData
      this.mFilteredGroupData = this.mAllGroupData
      this.dataSourceGroup = new MatTableDataSource(this.mFilteredGroupData);
      this.dataSourceGroup.sort = this.sort!
      this.dataSourceGroup.paginator = this.paginator!;


      // console.log(this.selectedCentre)
    })
  }

  searchChild($event: MatSelectChange) {
    this.selectedChildCode = $event.value

    let childObject = {

      'childCode': this.selectedChildCode.childCode,
      // 'age':this.selectedChildCode.age,
      'gender': this.selectedChildCode.gender,
      'unitCode': this.selectedChildCode.selectUnit,
      'childName': this.selectedChildCode.firstName + ' ' + this.selectedChildCode.lastName,
      "status": "Present",
      "isFollowUp":this.selectedChildCode.admissionData.length>2? 'Yes' : 'No'

    }

    if (this.showIndividual) this.fetchIndividualStudentData();
    if (this.showGroup) this.fetchGroupStudentData(childObject);

  }


  viewDialog(element: any) {
    this.matDialog.open(ViewEducationIndividualComponent, {
      data: element,
      width: '800%',
      height: '90%'
    })

  }

  getDateandTime(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy h:mm a ');
    return datePipeString
  }

  getDate(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy');
    return datePipeString
  }

  getTime(date: Date): any {
    let datePipeString: string | null = "NA"

    if (date != null) {
      let d = (date as unknown as Timestamp).toDate()
      datePipeString = this.datePipe.transform(d, "h:mm a")
      // console.log('DATEPIPE STRING',datePipeString )

      return datePipeString
    }
  }

  getCentresString(centres: any) {
    let arr: any[] = []
    centres.forEach((it: { centreName: any; }) => {
      arr.push(it.centreName)
    })
    return arr
  }

  getChildrenString(children: any) {
    let arr: any[] = []
    children.forEach((it: { childName: any; }) => {
      arr.push(' ' + it.childName)
    })
    return arr
  }

  viewDialog2(element: any) {
    this.matDialog.open(ViewEducationGroupComponent, {
      data: element,
      width: '800%',
      height: '90%'
    })

  }

  search() {
    if (this.selectedCentre != null) {
      this.childBycentre = this.childService.getAllotedChildListByCenter(this.selectedCentre!)
    }
  }

  showMessage(msg: string) {
    this.matSnackBar.open(msg, "OK", { duration: 3000 });
  }



  SearchButton() {

    // --- Individual ---
    if (this.showIndividual) {
      if (!this.mAllIndividualData || this.mAllIndividualData.length === 0) {
        this.showMessage("No individual session data found.");
      }
    }

    // --- Group ---
    if (this.showGroup) {
      if (!this.mAllGroupData || this.mAllGroupData.length === 0) {
        this.showMessage("No group session data found.");
      }
    }

  }

  clearAll() {
    this.selectedCentre =null
    this.selectedChildCode = null

  }

  individualFilter($event: MatSelectChange) {
    let filterData = this.mAllIndividualData.filter(x => x.sessionType == $event.value)
    this.dataSourceIndividual.data = filterData
    if($event.value=='All') this.dataSourceIndividual.data = this.mAllIndividualData

  }

  groupFilter($event: MatSelectChange) {

    let filterDataG = this.mAllGroupData.filter(x => x.sessionType == $event.value)
    this.dataSourceGroup.data = filterDataG
    if($event.value=='All') this.dataSourceGroup.data = this.mAllGroupData
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
